
  import { Component, Prop, Vue } from 'vue-property-decorator'

@Component({})
  export default class ExpandedItem extends Vue {
  @Prop({ type: String, default: () => '' }) readonly title!: string;
  @Prop({ type: [String, Object], default: () => '' }) readonly content!: string;
  @Prop({ type: String, default: () => '' }) readonly icon!: string;
  }
